module.exports = __webpack_public_path__ + "static/headphones-banner-sale-section-code-d6845beb08336da14e73cdd98777fd1a.png";